import { getExecEndpoint } from '../../service/getExecEndpoint';
import { Clause } from '~/api/def/endpoints/obligationsEndpoint';
import { defaultServer } from '~/api/def/servers/defaultServer';

export const clauseEndpoint = {
  server: defaultServer,
  path: 'obligations/clause',
  description: 'Get the clause',
};

const endpointClauseGetExec =
  getExecEndpoint<ClauseEndpointDef>(clauseEndpoint);
export const endpointClauseGET = async (urlExtra: string) =>
  endpointClauseGetExec<'GET'>({ method: 'GET', urlExtra });
export interface ClauseEndpointDef {
  endpoint: typeof clauseEndpoint;
  methods: {
    GET: {
      response: ClauseResponse;
    };
  };
}
export type ClauseResponse = {
  clause: Clause;
  doc: DocumentMeta;
  fullText: string;
};
export type DocumentMeta = {
  id: string; // documentId
  agreementTypeName: string;
  investor: string;
  name: string;
};
